import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { Easings } from '@picsart/design-system/foundation/easings';

const useStyles = createUseStyles(
  {
    mobileContent: {
      position: 'relative',
      height: '100%',
      overflow: 'hidden',
      backgroundColor: BackgroundColors.base,
    },
    screenLayer: {
      position: 'absolute',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: BackgroundColors.base,
      animation: `$fadeIn 0.25s ${Easings.easeOut}`,
      isolation: 'isolate',
    },
    hiddenLayer: {
      visibility: 'hidden',
      pointerEvents: 'none',
      animation: 'none',
    },
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
  },
  { name: 'mobileLayout' }
);

export default useStyles;
